import { AbstractControl } from '@angular/forms';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class CustomFormValidators {
    static isInputSpaces(control: AbstractControl): { isSpaces: boolean } | null {
        return (control.value && control.value.trim() === '') ? { isSpaces: true } : null;
    }
}
